import React from "react";
import AddIcon from "@mui/icons-material/Add";

import { theme } from "../../../constants/colors";

interface ButtonProps {
  onClick: () => void;
}

const AddAssetButton: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      style={{
        borderRadius: "5px",
        background: theme.colors.lightGrey,
        display: "flex",
        alignItems: "center",
        width: "40px",
        minWidth: "40px",
        height: "40px",
      }}
    >
      <AddIcon
        sx={{
          color: "white",
          alignSelf: "center",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      />
    </div>
  );
};

export default AddAssetButton;
